import { TTopUpStatus } from '@helpers/GetTopUpStatus/getTopUpStatus.types';

import { getCountry } from '../../../../iwIntlProvider/CountryProvider';

export function shouldShowPromotionAccordion(
    topupStatus: TTopUpStatus
): boolean {
    const country = getCountry();

    return (
        country !== 'DE' &&
        (topupStatus === 'NOT_YET_TOPUP_ELIGIBLE' ||
            topupStatus === 'TOPUP_DECLINED')
    );
}
